import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Wrapper } from './styled';
import Table from 'Screens/Credentials/components/Table';
import vulnDetailCredentialsSchema from '../schema';
import { selectIsFetching } from 'store/Credentials/selectors';

const DetailTable = () => {
  const [hidePass, setHidePass] = useState(true);
  const isFetching = useSelector(selectIsFetching);

  return (
    <Wrapper>
      <Table schema={ vulnDetailCredentialsSchema } context={ { hidePass, setHidePass, isFetching } } hidePass={ hidePass } setHidePass={ setHidePass } isVulnDetail />
    </Wrapper>
  );
};

export default DetailTable;
